
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/documents/[slug]",
      function () {
        return require("private-next-pages/documents/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/documents/[slug]"])
      });
    }
  